import React, { useState } from "react";

import "./App.css";

function App() {
  const [data, setData] = useState("");
  const [add, setAdd] = useState([]);
  const addData = () => {
    if (!data) {
      alert("Please enter some data");
    } else {
      setAdd([...add, data]);
      setData("");
    }
  };
  const deleteData = (id) => {
    console.log(id);
    const updatedData = add.filter((elem, ind) => {
      return ind !== id;
    });
    setAdd(updatedData);
  };

  return (
    <>
      <div className="content content--data">
        <div className="content__info">
          <input
            className="content__input"
            type="text"
            placeholder="Enter text here"
            value={data}
            onChange={(e) => setData(e.target.value)}
          />
          <span className="content__add" onClick={addData}>
            Add
          </span>
        </div>

        <div className="display display--info">
          {add.map((elem, ind) => {
            return (
              <div className="content__show" key={ind}>
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                <h2 className="content__text">&nbsp; {elem}</h2>
                <span
                  className="content__delete"
                  onClick={() => deleteData(ind)}
                >
                  Delete
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default App;
